import { render, staticRenderFns } from "./cLandingV3Editor.vue?vue&type=template&id=2fe09c97&scoped=true"
import script from "./cLandingV3Editor.vue?vue&type=script&lang=js"
export * from "./cLandingV3Editor.vue?vue&type=script&lang=js"
import style0 from "./cLandingV3Editor.vue?vue&type=style&index=0&id=2fe09c97&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe09c97",
  null
  
)

export default component.exports